import api from "../api";
import { JEWELLERY_API_ENDPOINTS } from "../../constants/jewellery.constant";

const replacePathParams = (path, params) => {
  let result = path;
  Object.keys(params).forEach((key) => {
    result = result.replace(`:${key}`, params[key]);
  });
  return result;
};

const paymentService = {
  // Create payment
  createPayment: async (paymentData) => {
    const response = await api.post(
      JEWELLERY_API_ENDPOINTS.CREATE_PAYMENT,
      paymentData
    );
    return response.data;
  },

  // Get all payments
  getAllPayments: async (filters = {}) => {
    const response = await api.get(JEWELLERY_API_ENDPOINTS.GET_ALL_PAYMENTS, {
      params: filters,
    });
    return response.data;
  },

  // Get pending payments
  getPendingPayments: async (filters = {}) => {
    const response = await api.get(
      JEWELLERY_API_ENDPOINTS.GET_PENDING_PAYMENTS,
      { params: filters }
    );
    return response.data;
  },

  // Get payment by ID
  getPaymentById: async (paymentId) => {
    const url = replacePathParams(JEWELLERY_API_ENDPOINTS.GET_PAYMENT_BY_ID, {
      id: paymentId,
    });
    const response = await api.get(url);
    return response.data;
  },

  // Verify payment
  verifyPayment: async (paymentId, verificationData) => {
    const url = replacePathParams(JEWELLERY_API_ENDPOINTS.VERIFY_PAYMENT, {
      id: paymentId,
    });
    const response = await api.patch(url, verificationData);
    return response.data;
  },

  // Reject payment
  rejectPayment: async (paymentId, rejectionData) => {
    const url = replacePathParams(JEWELLERY_API_ENDPOINTS.REJECT_PAYMENT, {
      id: paymentId,
    });
    const response = await api.patch(url, rejectionData);
    return response.data;
  },

  // Get plan payments
  getPlanPayments: async (planId, filters = {}) => {
    const url = replacePathParams(JEWELLERY_API_ENDPOINTS.GET_PLAN_PAYMENTS, {
      planId,
    });
    const response = await api.get(url, { params: filters });
    return response.data;
  },

  // Get customer payments
  getCustomerPayments: async (customerId, filters = {}) => {
    const url = replacePathParams(
      JEWELLERY_API_ENDPOINTS.GET_CUSTOMER_PAYMENTS,
      { customerId }
    );
    const response = await api.get(url, { params: filters });
    return response.data;
  },
};

export default paymentService;
